// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"95b166ca","229":"3363eebb","462":"80db99bd"}[chunkId] + ".chunk.js";
};